import axios from 'axios'
import { baseUrl } from '../constants/Connections'
import { tryToJson } from '../utils/util'

export async function login({ email, password }) {
    const options = {
        method: 'POST',
        url: `${baseUrl}/api/login`,
        data: {
            email: email,
            password: password,
        },
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function request_new_password(data) {
    const options = {
        method: 'POST',
        url: `${baseUrl}/api/reset_password`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function checkSolutionAccess(data) {
    const token = await localStorage.getItem('userToken')
    const options = {
        headers: {
            Authorization: `${token}`,
        },
        method: 'POST',
        url: `${baseUrl}/api/checkSolutionAccess`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getTasksRewardingPoints() {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/rewarding_points`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getUsersRewardingPoints() {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/rewarding_points/user`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function isChatDisabledAsync() {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/is_chat_disabled`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getActiveAchievements() {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/user_achievement/active`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getSingleActiveAchievement() {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/user_achievement/single_active`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getCheckUsersFeedback() {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/check_if_users_feedback_is_needed`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function sendRejectReview() {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/reject_review`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function collectUsersFeedback(data) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/collect_users_feedback`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getFinishedAchievements() {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/user_achievement/done`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getUnseenConversations() {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/unseen_conversations`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function contactExpert(data) {
    const token = await localStorage.getItem('userToken')

    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/contactExpert`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getResponseSuggestions({ answer, locale }) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'post',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/get_response_suggestions`,
        data: {
            response: answer,
            locale,
        },
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function find_counsellor(data) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/find_counsellor`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function find_sos(data) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/find_sos`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function checkIfTakeDailyFeedback(user_id) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/last_daily_feedback/${user_id}`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function answer(data) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/answer`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getFeeds({ user, number_of_feeds }) {
    const token = await localStorage.getItem('userToken')
    const data = {
        user,
        number_of_feeds,
    }
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/get_feed`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function takeTutorial(currentStep) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/take_tutorial?device=desktop&step=${currentStep}`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function ifUserNeedsTutorial() {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/need_tutorial?device=desktop`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const respondToDailyQuestion = async (data) => {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
        },
        url: `${baseUrl}/api/respondToDailyQuestion`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function searchFeeds({ user, number_of_feeds, text }) {
    const token = await localStorage.getItem('userToken')
    const data = {
        user,
        number_of_feeds,
        text,
        scroll_enabled: true,
    }
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/get_feed`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getTasks({ user_id, number_of_tasks }) {
    const token = await localStorage.getItem('userToken')
    const data = {
        user_id,
        number_of_tasks,
    }
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api_v2/get_task`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getArchive({ user_id, number_of_archives, collection }) {
    const token = await localStorage.getItem('userToken')
    const data = {
        user_id,
        number_of_archives,
        collection,
    }
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/get_archive`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function like({ user_id, feed_id, like }) {
    const token = await localStorage.getItem('userToken')
    const data = {
        user_id,
        feed_id,
        like,
    }
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/like`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getMessageList({ data }) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/message_list`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getMessages({ members, loaded_messages, conversation_id }) {
    const token = await localStorage.getItem('userToken')
    const data = {
        members,
        loaded_messages,
        conversation_id,
    }
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/get_messages`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getBy({ collection = '', query = '', page = -1, page_size = -1, sort_field = '', sort_direction = 1 }) {
    const token = await localStorage.getItem('userToken')
    const args = `?page=${page}&page_size=${page_size}&sort_field=${sort_field}&sort_direction=${sort_direction}&query=${JSON.stringify(query)}`
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/filter_by/${collection}${args}`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getByToken() {
    const token = await localStorage.getItem('userToken')
    if (!token) {
        return { status: 400, message: 'Token is Null' }
    }
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/users/by_token/${token}`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function draftSurveyAsync(data) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/draft_survey_response`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getById({ collection, id }) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/by_id/${collection}/${id}`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getByInstitution({ collection, institution_id }) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/filter_by_institution/${collection}/${institution_id}`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getSurveys() {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/get_student_surveys`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const create = async ({ collection, data }) => {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
        },
        url: `${baseUrl}/api/all/${collection}`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function update({ collection, data }) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'PUT',
        headers: {
            Authorization: `${token}`,
        },
        data: data,
        url: `${baseUrl}/api/by_id/${collection}/${data?.id}`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function deleteById({ collection, id }) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'DELETE',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/by_id/${collection}/${id}`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function update_new_password({ email, password, token }) {
    const data = {
        email,
        password,
        token,
    }
    const options = {
        method: 'PUT',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/update_new_password`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function find_head_of_class(data) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/find_head_of_class`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function verify_reset_token({ email, token }) {
    const options = {
        method: 'GET',
        url: `${baseUrl}/api/verify_reset_token/${email}/${token}`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function get_chat_config() {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/chat_config`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function sendNotification({ data }) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/sendNotification`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function sendMessageAsync(data) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/send_message`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getIssues({ issueType, loadedContent, searchText, local }) {
    const token = await localStorage.getItem('userToken')
    const data = {
        loadedContent: loadedContent,
        issueType: issueType,
        searchText: searchText || '',
        local: local,
    }

    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/get_issues`,
        data,
    }

    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function solutionLike(data) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/solutionLike`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function logUserTimeAsync(data) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/log_user_time`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function logLoginTimeAsync(data) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/log_login_time`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function solutionDislike(data) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/solutionDislike`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function viewFeedPost(data) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/view_post`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function createConversation(data) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/create_conversation`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const agreeToTermsAndPolicy = async (user) => {
    const token = localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        date: Date.now(),
        headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
        },
        url: `${baseUrl}/api/agreeToTermsAndPolicy`,
        data: user,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const disagreeToTermsAndPolicy = async (user) => {
    const token = localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
        },
        url: `${baseUrl}/api/disagreeToTermsAndPolicy`,
        data: user,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function seenMessage(data) {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/seen_message`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getJournalForUser = async (id) => {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/journal_for_user/${id}`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const updateJournalDailyQuestion = async (user) => {
    const token = await localStorage.getItem('userToken')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
        },
        url: `${baseUrl}/api/respond_to_journal_question`,
        data: user,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

function handelError(error) {
    return { status: error?.response?.status, data: error?.response?.data }
}
function handleSuccess(response) {
    const responseData = tryToJson(response.data)
    return { status: response.status, data: responseData }
}
